<template>
	<div id="container" class="page-container" @click="categoryPageClick" v-if="showFlag">
		<a-spin :spinning="reloadSpinning">
			<div>
				<!-- <Font @setOffsetTop="setOffsetTop"></Font> -->
				<div :style="scrolldiv" @scroll="handleScroll" class="scrolldiv weekscroll" ref="scrolldivRef">


						<div class="banner-area">
							<div class="banner-card">
								<div class="banner-left">
									<div class="icon-round">
										<img
											src="https://enplus.oss-cn-guangzhou.aliyuncs.com/file/66cc65b6-d3fe-40a8-ada9-8c78bdd5bdd2.png" />
									</div>
								</div>
								<div class="banner-right">
									<div class="banner-title">{{ extractedData.articleTitle }}</div>

								</div>
							</div>

							<div class="tabs" style="align-items: center;">
								<div v-for="(t, i) in tabs" :key="i" class="tab" :class="{ active: activeTab === i }"
									@click="activeTab = i">
									{{ t }}
								</div>
								<a-button @click="toCopy"  style="font-size: 13px;
    background: #06a1a3;
    color: white;
    border-radius: 10px;
    padding: 2px 8px;">复制全文</a-button>
							</div>
						</div>

						<div class="list-area" style="padding:5px 40px 40px 40px">
							<!-- 分节头 + 可折叠卡片列表视图（与设计图一致） -->
							<div v-for="(section, idx) in previewCards" :key="idx" class="section-block">
								<template v-if="section.sectionshow">
								<div class="section-header">
									<div class="section-left">
										<div class="mark"></div>

										<div class="section-title-text">{{ section.preTitle }}</div>
									</div>

								</div>

								<div class="cards-container" >
									<!-- 预览模式下使用图片中的静态卡片数据（数组驱动渲染） -->
									<div class="cards-inner">
										<div v-for="(card, cardIdx) in section.children" :key="cardIdx"
											:data-idx="cardIdx" >
											<template v-if="card.items && card.items.length > 0">
												<div class="section-header" :key="itemIdx" >
													<div class="section-left">
														<template v-if="card.subTitle&&card.subTitle!=''">
															<div class="mark"></div>

														<div class="section-title-text">{{ card.subTitle }}</div>
														</template>
														<UpOutlined @click="card.subTitleShow = false"  style="margin-left: auto;" v-if="card.subTitleShow"/>
													
													   <DownOutlined @click="card.subTitleShow = true" style="margin-left: auto;" v-else/>
													</div>


												</div>
												<template v-if="card.subTitleShow">
													<div v-for="(value, valueIndex) in card.items" :key="valueIndex">
													<div :class="{ expanded: value.expanded,'report-card':true }">
														<div>
															<text class="pill-tag" v-if="value.tag!=null && value.tag!=''">{{ value.tag }}</text>
															<text class="card-title">{{ value.title }}</text>
														</div>
														<p style="font-size:16px;text-align: justify;" :ref="(el) => setTextRef(el, 1, idx, valueIndex)">{{
															value.content }}</p>

														<a v-if="value.show"
															:class="['expand-btn', value.expanded ? 'disexpand-btn' : '']"
															href="javascript:;"
															@click.prevent="toggleCardExpand(1, idx, valueIndex)">
															{{ value.expanded ? '收起全文' : '展开全文' }}
														</a>
														<div class="meta" >
															<template v-if="value.sources.length > 0">
<template v-for="(m, mi) in value.sources">
																<span v-if="mi !== 0" class="dot"></span>
																<img style="    width: 20px;" v-else
																	src="https://enplus.oss-cn-guangzhou.aliyuncs.com/file/3a71c59b-a645-48f9-b04f-5a14d63e1f11.png">
																<span>{{ m.title }}</span>
																<span>{{ m.time }}</span>

															</template>
															</template>
															


															<div v-if="value.links != ''" v-html="value.links"
																ref="htmlContainer"
																@click.stop="aiContentClick($event)"></div>


														</div>

													</div>
												</div>
												</template>
											</template>
											<template v-else>
												<div :class="{ expanded: card.expanded,'report-card':true }">
													<div>
														<text class="pill-tag" v-if="card.tag!=null && card.tag!=''">{{ card.tag }}</text>
														<text class="card-title">{{ card.subTitle }}</text>
													</div>
													<p style="font-size:16px;text-align: justify;" :ref="(el) => setTextRef(el, 0, idx)">{{ card.content }}</p>

													<a v-if="card.show"
														:class="['expand-btn', card.expanded ? 'disexpand-btn' : '']"
														href="javascript:;" @click.prevent="toggleCardExpand(0, idx)">
														{{ card.expanded ? '收起全文' : '展开全文' }}
													</a>



												</div>

											</template>

										</div>
									</div>


								</div>
								</template>
							</div>
							<div @click.stop="clickLinkArticle" id="linkArticle"
								:style='{ display: linkArticle.display, top: linkArticle.top, "z-index": linkArticle.index }'
								class="linkArticle">
								<div @click.stop="clickLinkArticleItem(linkitem)"
									style="display: flex;    align-items: center;"
									v-for="(linkitem, linkIndex) in linkList" v-bind:key="linkIndex">
									<div class="linkItem">{{ linkitem.index }}、{{ linkitem.title }}

									</div>
									<img :src="linkSrc" style="width: 15px;height: 15px;" />
								</div>

							</div>
							<div>小Q周报由AI自动生成，使用时请注意甄别。</div>
						</div>
				
				</div>
			</div>
		</a-spin>
	</div>
	<WeeklyArticleDetail1 v-else></WeeklyArticleDetail1>
</template>
<script>


import useClipboard from 'vue-clipboard3'
import $ from 'jquery'
import {UpOutlined,DownOutlined} from '@ant-design/icons-vue'
import Font from '../articleComponent/Font.vue'
import { toDoArticleRecord } from './js/index'
import { getLoginUserInfo } from '../../views/js/index'
import { useRouter } from 'vue-router';
import { guestArticle, readList } from '../articleComponent/js/index'
import { onMounted, watch, ref, onDeactivated, onActivated } from 'vue'
import store from '@/store';
import router from '@/router';
import { nextTick } from 'vue';
import WeeklyArticleDetail1 from './weeklyArticleDetail1.vue';
import { message } from 'ant-design-vue/lib/components.js'

export default {
	name: 'weeklyArticleDetail',
	components: { Font, WeeklyArticleDetail1, UpOutlined,DownOutlined },

	setup() {
		const showFlag=ref(true)
		watch(() => store.getters.fontSize, (val, oldVal) => {
			fontSize.value = val
			toGetResize(fontSize.value, oldVal, aiContent.value)

		})
		const $router = useRouter();
		watch(
			() => $router.currentRoute.value.query,
			(val, old) => {
				if ($router.currentRoute.value.path.indexOf('weeklyArticleDetail') > -1 && val && val.warticleId) {
					aiCategoryId.value = val.warticleId
					if (store.getters.companyList && store.getters.company) {
						var result = store.getters.companyList.find(item => item.companyId == store.getters.company.companyId)
						if (result) {
							todayImg.value = result.todayImg
							toShowDetail()
						}
						else {
							toGetUserInfor()
						}
					}
					else {
						toGetUserInfor()
					}
				}
				//如果不是文章返回的到文章列表 重置数据



			})
		onDeactivated(() => {


			toDoArticleRecord(aiCategoryId.value, 2)


		})
		onActivated(() => {

			fontSize.value = store.getters.fontSize
			toGetResize(fontSize.value, 2, aiContent.value)

			if (aiContent.value == null || aiContent.value == '') {
				if ($router.currentRoute.value.query.warticleId) {
					aiCategoryId.value = $router.currentRoute.value.query.warticleId
					if (store.getters.company) {
						todayImg.value = store.getters.company.todayImg

						toShowDetail()
					}
					else {
						toGetUserInfor()
					}
				}
			}

			document.querySelector('.scrolldiv').scrollTop = scrollY.value
		})
		const extractedData = ref('')

		const previewCards = ref([])


		const toShowDetail = async () => {
			activeTab.value = 0
			var height = document.getElementById('container').offsetHeight
			scrolldiv.value = { height: (height - 20) + 'px', overflow: 'auto' }
			reloadSpinning.value = true
			await guestArticle({ id: aiCategoryId.value }).then(async (res) => {
				aiContent.value = res.data.content
				console.log(res.data.content, 'res.data.content')
				try{
					
				
				extractedData.value = extractDataFromHTML(aiContent.value) // 调用提取函数
				if(!extractedData.value || !extractedData.value.sections || extractedData.value.sections.length === 0){
					this.showFlag.value=false 
					throw new Error('No sections found in extracted data'); 
				}
				tabs.value = extractedData.value.sections.map(section => section.title)
				tabs.value.unshift('全部') // 输出提取结果
				previewCards.value = extractedData.value.sections
				console.log(extractedData.value, 'extractedData.value')
				reloadSpinning.value = false
				showFlag.value=true
		
				toDoArticleRecord(aiCategoryId.value, 0)
				nextTick(() => {

					if (aiCategoryId.value) {
						$('.ai-category a').removeAttr('href');
						// console.log($('.ai-category').html(),'outerHTMLxixi')
						// if($('.ai-category')[0])
						// aiContent.value=$('.ai-category')[0].outerHTML;
					}
					// setOffsetTop()
				})
			   }catch{
                  showFlag.value=false
			   }
			})





		}



		const reloadSpinning = ref(false)

		const scrolldiv = ref('')


		const todayImg = ref('')
		const tabs = ref(null)
		const aiContent = ref('')

		const checkTextOverflow = (value, idx, index) => {
			if (index)
				var el = textRefs.value[value][idx][index];
			else
				var el = textRefs.value[value][idx];

			var card = null;
			console.log(value, idx, index, 'checkTextOverflow', previewCards.value)
			if (value == 0)
				card = previewCards.value[idx].children[0];
			else if (value == 1) {
				card = previewCards.value[idx].children[1].items[index];
			}
			if (!el || !card) return;
			nextTick(() => {


				// 判断是否超过3行
				const isOverflow = el.scrollHeight > el.clientHeight;
				// 更新 card.show
				card.show = isOverflow;
			});

		};


		// 切换展开/收起
		const toggleCardExpand = (value, idx, index) => {
			var card = null
			if (value == 0) {
				card = previewCards.value[idx].children[0];

			}
			else {
				card = previewCards.value[idx].children[1].items[index];
			}

			card.expanded = !card.expanded;


		};



		const toGetUserInfor = () => {

			getLoginUserInfo().then((res) => {
				store.dispatch('companyList', res.data.sysClient.companyVos[0])
				toShowDetail()
			})
		}

		const scrollY = ref(0)
		const fontSize = ref('')



		const aiCategoryId = ref(null)

		const linkList = ref([])
		const aiContentClick = (event) => {
			console.log(event, 'event')
			if (event.target.className == 'quote') {
				var list = []

				var eLinkList = event.target.attributes['data-href'].value.split("==")
				var eTitleList = event.target.attributes['data-title'].value.split("==")
				var eIndexList = event.target.attributes['data-index'].value.split("==")
				for (var i in eLinkList) {
					list.push({
						title: eTitleList[i],
						href: eLinkList[i],
						index: eIndexList[i]
					})
				}
				console.log(list, 'linkList')
				linkList.value = list
				linkArticle.value = {
					'display': 'block',
					'top': event.target.offsetTop + 'px',
					'index': 0
				}
				nextTick(() => {

					linkArticle.value.top = (event.target.offsetTop - $('.linkArticle').height() - 27) + 'px'
					linkArticle.value.index = 10
					// 创建一个选择器查询对象，.in(this)确保查询在当前页面的上下文中进行，而不是全局的上下文
					// const query = uni.createSelectorQuery().in(this);
					// var  superThis = this 
					// // boundingClientRect 会返回元素的边界信息（如宽度、高度、位置等）
					// query.select('#linkArticle').boundingClientRect(rect => {

					// 	superThis.linkArticle.top=(e.detail.y-rect.height-27)+'px'
					// 	superThis.linkArticle.index=10
					// 	}).exec();

				})

			} else linkArticle.value.display = 'none'

		}
		const linkArticle = ref({

			display: 'block',
			top: '-50px',
			index: -10


		})



		const clickLinkArticle = () => {
			return
		}
		const clickLinkArticleItem = (item) => {
			console.log(item, 'clickLinkArticleItem')
			linkArticle.value.display = 'none'
			router.push({ name: 'articleDetail', query: { articleId: item.href } })

		}
		const categoryPageClick = () => {

			linkArticle.value.display = 'none'
		}
		const toGetResize = (val, oldVal, htmlContent) => {
			if (val == oldVal) {
				aiContent.value = htmlContent;
			}
			htmlContent = htmlContent.replace(/font-size:\d{1,20}px/g, function (param) {
				var result = param.substring(param.indexOf(':') + 1, param.indexOf('p'))
				return 'font-size:' + (Number(result) + (val - oldVal) * 2) + 'px'
			})
			aiContent.value = htmlContent;
		}
		const offsetTop = ref(0)
		const collapsedList = ref([])

		// tabs and banner for 周报 列表视图

		const activeTab = ref(0)
		const scrolldivRef=ref(null)
		watch(()=>activeTab.value, (newVal) => {
			if(scrolldivRef.value)
		scrolldivRef.value.scrollTop = 0; // 切换 tab 时重置滚动条位置	
			if (newVal === 0) {
				// 显示全部
				previewCards.value.forEach(section => {
					section.sectionshow = true;
				});
			} else {
				// 显示对应的分节
				previewCards.value.forEach((section, index) => {
					section.sectionshow = index === newVal - 1;
				});
			}
		});
		const bannerTitle = ref('2026年 第32周周报')
		const dateRange = ref('08.01—08.07')
		const totalCount = ref(36)

		// 折叠控制：点击节头可以收起 / 展开
		const collapsed = ref(false)
		const toggleSection = () => { collapsed.value = !collapsed.value }

		const setOffsetTop = () => {
			var element = document.getElementsByClassName('fontResize')

			offsetTop.value = element[0].clientHeight + 'px'
		}
		// 存储 p 元素引用
		const textRefs = ref({
			0: {},
			1: {}
		});

		// ✅ 定义 setTextRef 函数
		const setTextRef = (el, value, idx, index) => {
			if (el) {
				if (index) {
					if (textRefs.value[value][idx][index]) return
					else textRefs.value[value][idx][index] = el;
				}

				else {
					if (textRefs.value[value][idx]) return
					else textRefs.value[value][idx] = el;
				}

				// 元素挂载后立即判断
				//checkTextOverflow(value, idx, index);
			}
		};
// const extractDataFromHTML = (html) => {
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, 'text/html');

//     const h2s = doc.querySelectorAll('h2');
//     const articleTitle = Array.from(h2s).map(h2 => h2.textContent.trim()).join('');

//     const sectionsData = [];

//     const rootUl = doc.querySelector('div.ai-category > ul');
//     if (!rootUl) {
//         // 使用 fallback 方法
//         return extractWithFallback(doc, h2s);
//     }

//     const rootLis = rootUl.querySelectorAll(':scope > li');
//     let currentSection = null;
//     let sectionChildren = [];

//     // ---- 检查是否包含加粗标签 ----
//     function hasBoldTag(li) {
//         return li.querySelector('[style*="font-weight"]') !== null;
//     }

//     // ---- 检查是否没有加粗标签但有内容（纯文本 或 只有 a 标签） ----
//     function isPlainTextLi(li) {
//         // 如果包含加粗标签，不是综合分析
//         if (hasBoldTag(li)) {
//             return false;
//         }
//         // 有内容（纯文本 或 a 标签）
//         const text = li.textContent.trim();
//         return text.length > 0;
//     }

//     function getBoldText(li) {
//         const boldEl = li.querySelector('[style*="font-weight"]');
//         return boldEl ? boldEl.textContent.trim().replace(/[:：]$/, '').trim() : '';
//     }

//     // ---- 获取内容（移除 a 标签和来源） ----
//     function getContent(li) {
//         const clone = li.cloneNode(true);

//         // 移除加粗标签
//         clone.querySelectorAll('[style*="font-weight"]').forEach(el => el.remove());
//         // 移除 a 标签
//         clone.querySelectorAll('a.quote').forEach(el => el.remove());
//         // 移除 br 标签
//         clone.querySelectorAll('br').forEach(el => el.remove());

//         let content = clone.textContent.trim();

//         // 去掉标题部分（冒号前的内容）
//         const match = content.match(/^[^：:]*[：:]\s*/);
//         if (match) {
//             content = content.substring(match[0].length);
//         }

//         // 移除来源
//         content = content.replace(/[（(][^）)]+[）)]/g, '').trim();
//         // 清理多余空白
//         content = content.replace(/\s+/g, ' ').trim();

//         return content;
//     }

//     // ---- 提取 a 标签，删除 href 属性 ----
//     function extractLinksHtml(htmlString) {
//         if (!htmlString) return '';
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = htmlString;
//         const aTags = tempDiv.querySelectorAll('a.quote');
//         if (aTags.length === 0) return '';
//         return Array.from(aTags).map(a => {
//             const clone = a.cloneNode(true);
//             clone.removeAttribute('href');
//             return clone.outerHTML;
//         }).join('');
//     }

//     // ---- 修正：支持多个来源用分号连接 ----
//     function extractSources(text) {
//         if (!text) return [];
//         const sources = [];

//         // 匹配 （来源名，日期） 或 （来源名 日期） 格式
//         const multiRegex = /[（(]([^）)]+)[）)]/g;
//         let match;
//         while ((match = multiRegex.exec(text)) !== null) {
//             const content = match[1];
//             const parts = content.split(/[；;]\s*/);
//             for (const part of parts) {
//                 // 尝试匹配 来源名, 日期
//                 let itemMatch = part.match(/^([^，,]+)[，,]\s*(\d{4}-\d{2}-\d{2})/);
//                 if (!itemMatch) {
//                     // 尝试匹配 来源名 日期（空格分隔）
//                     itemMatch = part.match(/^(.+?)\s+(\d{4}-\d{2}-\d{2})$/);
//                 }
//                 if (itemMatch) {
//                     sources.push({
//                         title: itemMatch[1].trim(),
//                         time: itemMatch[2].trim()
//                     });
//                 }
//             }
//         }

//         // 如果没有分号，尝试直接匹配
//         if (sources.length === 0) {
//             // 匹配 （来源名, 日期）
//             const regex = /[（(]([^，,）)]+)[，,]\s*(\d{4}-\d{2}-\d{2})[）)]/g;
//             while ((match = regex.exec(text)) !== null) {
//                 sources.push({
//                     title: match[1].trim(),
//                     time: match[2].trim()
//                 });
//             }
//             // 匹配 （来源名 日期）
//             const regexSpace = /[（(](.+?)\s+(\d{4}-\d{2}-\d{2})[）)]/g;
//             while ((match = regexSpace.exec(text)) !== null) {
//                 const exists = sources.some(s => s.title === match[1].trim() && s.time === match[2].trim());
//                 if (!exists) {
//                     sources.push({
//                         title: match[1].trim(),
//                         time: match[2].trim()
//                     });
//                 }
//             }
//         }

//         return sources;
//     }

//     function cleanLevel1Title(text) {
//         return text.replace(/^[一二三四五六七八九十]、\s*/, '');
//     }

//     function isLevel1(text) {
//         return /^[一二三四五六七八九十]、/.test(text);
//     }

//     function isSummary(text) {
//         return text === '综合分析';
//     }

//     for (let i = 0; i < rootLis.length; i++) {
//         const li = rootLis[i];
//         const boldText = getBoldText(li);
//         const hasBold = hasBoldTag(li);
//         const isPlainText = isPlainTextLi(li);
//         const innerText = li.textContent.trim();

//         console.log(`li[${i}] boldText:`, boldText, 'hasBold:', hasBold, 'isPlainText:', isPlainText);

//         // ---- 情况：没有加粗标签，有内容 → 综合分析 ----
//         if (isPlainText && innerText && !hasBold) {
//             if (currentSection) {
//                 // 检查是否已经添加过综合分析
//                 const hasSummary = sectionChildren.some(child => child.tag === '综合分析' || child.tag === '');
//                 if (!hasSummary) {
//                     const originalHtml = li.innerHTML;
//                     const content = getContent(li);
//                     sectionChildren.push({
//                         tag: '综合分析',
//                         subTitle: '',
//                         content: content || innerText,
//                         links: extractLinksHtml(originalHtml),
//                         sources: extractSources(originalHtml || innerText)
//                     });
//                 }
//             }
//             continue;
//         }

//         if (!boldText) continue;

//         // ---- 一级标题 ----
//         if (isLevel1(boldText)) {
//             if (currentSection) {
//                 currentSection.children = sectionChildren;
//                 sectionsData.push(currentSection);
//             }

//             currentSection = {
//                 title: cleanLevel1Title(boldText),
//                 preTitle: boldText,
//                 children: [],
//                 show: false,
//                 sectionshow: true
//             };
//             sectionChildren = [];

//             const nextLi = rootLis[i + 1];
//             if (nextLi) {
//                 const nextBold = getBoldText(nextLi);
//                 const nextIsPlainText = isPlainTextLi(nextLi);
//                 const nextInnerText = nextLi.textContent.trim();
//                 const nextHasBold = hasBoldTag(nextLi);

//                 // 下一个 li 是综合分析（没有加粗标签但有内容）或有"综合分析"标签
//                 if (nextIsPlainText && nextInnerText && !nextHasBold) {
//                     const originalHtml = nextLi.innerHTML;
//                     const content = getContent(nextLi);
//                     sectionChildren.push({
//                         tag: '综合分析',
//                         subTitle: '',
//                         content: content || nextInnerText,
//                         links: extractLinksHtml(originalHtml),
//                         sources: extractSources(originalHtml || nextInnerText)
//                     });
//                     i++;
//                     continue;
//                 } else if (isSummary(nextBold)) {
//                     const originalHtml = nextLi.innerHTML;
//                     const content = getContent(nextLi);
//                     sectionChildren.push({
//                         tag: nextBold,
//                         subTitle: '',
//                         content: content,
//                         links: extractLinksHtml(originalHtml),
//                         sources: extractSources(originalHtml)
//                     });
//                     i++;
//                     continue;
//                 }
//             }
//             continue;
//         }

//         // ---- 二级标题 ----
//         if (currentSection && !isSummary(boldText)) {
//             const innerUl = li.querySelector(':scope > ul');

//             if (innerUl) {
//                 const subTitle = boldText;
//                 const items = [];

//                 const subLis = innerUl.querySelectorAll(':scope > li');
//                 for (const subLi of subLis) {
//                     const subBold = getBoldText(subLi);
//                     if (!subBold) {
//                         const originalHtml = subLi.innerHTML;
//                         const content = getContent(subLi);
//                         if (content) {
//                             items.push({
//                                 tag: '',
//                                 title: '',
//                                 content,
//                                 links: extractLinksHtml(originalHtml),
//                                 sources: extractSources(originalHtml)
//                             });
//                         }
//                         continue;
//                     }

//                     const tagMatch = subBold.match(/【([^】]+)】/);
//                     const tag = tagMatch ? tagMatch[1] : '';
//                     const itemTitle = subBold.replace(/【[^】]+】/, '').trim();
//                     const originalHtml = subLi.innerHTML;
//                     const content = getContent(subLi);

//                     if (itemTitle || content) {
//                         items.push({
//                             tag,
//                             title: itemTitle,
//                             content,
//                             links: extractLinksHtml(originalHtml),
//                             sources: extractSources(originalHtml)
//                         });
//                     }
//                 }

//                 if (items.length > 0) {
//                     sectionChildren.push({ subTitle, items, subTitleShow: true });
//                 }
//             }
//         }
//     }

//     if (currentSection) {
//         currentSection.children = sectionChildren;
//         sectionsData.push(currentSection);
//     }

//     // 如果 sectionsData 为空，使用 fallback 方法
//     if (sectionsData.length === 0) {
//         return extractWithFallback(doc, h2s);
//     }

//     return { articleTitle, sections: sectionsData };
// };

const extractDataFromHTML = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const h2s = doc.querySelectorAll('h2');
    const articleTitle = Array.from(h2s).map(h2 => h2.textContent.trim()).join('');

    const sectionsData = [];

    const rootUl = doc.querySelector('div.ai-category > ul');
    if (!rootUl) {
        // 使用 fallback 方法
        return extractWithFallback(doc, h2s);
    }

    const rootLis = rootUl.querySelectorAll(':scope > li');
    let currentSection = null;
    let sectionChildren = [];

    // ---- 检查是否包含加粗标签 ----
    function hasBoldTag(li) {
        return li.querySelector('[style*="font-weight"]') !== null;
    }

    // ---- 检查是否没有加粗标签但有内容（纯文本 或 只有 a 标签） ----
    function isPlainTextLi(li) {
        // 如果包含加粗标签，不是综合分析
        if (hasBoldTag(li)) {
            return false;
        }
        // 有内容（纯文本 或 a 标签）
        const text = li.textContent.trim();
        return text.length > 0;
    }

    function getBoldText(li) {
        const boldEl = li.querySelector('[style*="font-weight"]');
        return boldEl ? boldEl.textContent.trim().replace(/[:：]$/, '').trim() : '';
    }

    // ---- 获取内容（移除 a 标签和来源） ----
    function getContent(li) {
        const clone = li.cloneNode(true);

        // 移除加粗标签
        clone.querySelectorAll('[style*="font-weight"]').forEach(el => el.remove());
        // 移除 a 标签
        clone.querySelectorAll('a.quote').forEach(el => el.remove());
        // 移除 br 标签
        clone.querySelectorAll('br').forEach(el => el.remove());

        let content = clone.textContent.trim();

        // 去掉标题部分（冒号前的内容）
        const match = content.match(/^[^：:]*[：:]\s*/);
        if (match) {
            content = content.substring(match[0].length);
        }

        // 移除来源
        content = content.replace(/[（(][^）)]+[）)]/g, '').trim();
        // 清理多余空白
        content = content.replace(/\s+/g, ' ').trim();

        return content;
    }

    // ---- 提取 a 标签，删除 href 属性 ----
    function extractLinksHtml(htmlString) {
        if (!htmlString) return '';
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        const aTags = tempDiv.querySelectorAll('a.quote');
        if (aTags.length === 0) return '';
        return Array.from(aTags).map(a => {
            const clone = a.cloneNode(true);
            clone.removeAttribute('href');
            return clone.outerHTML;
        }).join('');
    }

    // ---- 修正：支持多个来源用分号连接 ----
    function extractSources(text) {
        if (!text) return [];
        const sources = [];

        // 匹配 （来源名，日期） 或 （来源名 日期） 格式
        const multiRegex = /[（(]([^）)]+)[）)]/g;
        let match;
        while ((match = multiRegex.exec(text)) !== null) {
            const content = match[1];
            const parts = content.split(/[；;]\s*/);
            for (const part of parts) {
                // 尝试匹配 来源名, 日期
                let itemMatch = part.match(/^([^，,]+)[，,]\s*(\d{4}-\d{2}-\d{2})/);
                if (!itemMatch) {
                    // 尝试匹配 来源名 日期（空格分隔）
                    itemMatch = part.match(/^(.+?)\s+(\d{4}-\d{2}-\d{2})$/);
                }
                if (itemMatch) {
                    sources.push({
                        title: itemMatch[1].trim(),
                        time: itemMatch[2].trim()
                    });
                }
            }
        }

        // 如果没有分号，尝试直接匹配
        if (sources.length === 0) {
            // 匹配 （来源名, 日期）
            const regex = /[（(]([^，,）)]+)[，,]\s*(\d{4}-\d{2}-\d{2})[）)]/g;
            while ((match = regex.exec(text)) !== null) {
                sources.push({
                    title: match[1].trim(),
                    time: match[2].trim()
                });
            }
            // 匹配 （来源名 日期）
            const regexSpace = /[（(](.+?)\s+(\d{4}-\d{2}-\d{2})[）)]/g;
            while ((match = regexSpace.exec(text)) !== null) {
                const exists = sources.some(s => s.title === match[1].trim() && s.time === match[2].trim());
                if (!exists) {
                    sources.push({
                        title: match[1].trim(),
                        time: match[2].trim()
                    });
                }
            }
        }

        return sources;
    }

    function cleanLevel1Title(text) {
        return text.replace(/^[一二三四五六七八九十]、\s*/, '');
    }

    function isLevel1(text) {
        return /^[一二三四五六七八九十]、/.test(text);
    }

    function isSummary(text) {
        return text === '综合分析';
    }

    for (let i = 0; i < rootLis.length; i++) {
        const li = rootLis[i];
        const boldText = getBoldText(li);
        const hasBold = hasBoldTag(li);
        const isPlainText = isPlainTextLi(li);
        const innerText = li.textContent.trim();

        console.log(`li[${i}] boldText:`, boldText, 'hasBold:', hasBold, 'isPlainText:', isPlainText);

        // ---- 情况：没有加粗标签，有内容 → 综合分析 ----
        if (isPlainText && innerText && !hasBold) {
            if (currentSection) {
                // 检查是否已经添加过综合分析
                const hasSummary = sectionChildren.some(child => child.tag === '综合分析' || child.tag === '');
                if (!hasSummary) {
                    const originalHtml = li.innerHTML;
                    const content = getContent(li);
                    sectionChildren.push({
                        tag: '综合分析',
                        subTitle: '',
                        content: content || innerText,
                        links: extractLinksHtml(originalHtml),
                        sources: extractSources(originalHtml || innerText)
                    });
                }
            }
            continue;
        }

        if (!boldText) continue;

        // ---- 一级标题 ----
        if (isLevel1(boldText)) {
            if (currentSection) {
                currentSection.children = sectionChildren;
                sectionsData.push(currentSection);
            }

            currentSection = {
                title: cleanLevel1Title(boldText),
                preTitle: boldText,
                children: [],
                show: false,
                sectionshow: true
            };
            sectionChildren = [];

            const nextLi = rootLis[i + 1];
            if (nextLi) {
                const nextBold = getBoldText(nextLi);
                const nextIsPlainText = isPlainTextLi(nextLi);
                const nextInnerText = nextLi.textContent.trim();
                const nextHasBold = hasBoldTag(nextLi);

                // 下一个 li 是综合分析（没有加粗标签但有内容）或有"综合分析"标签
                if (nextIsPlainText && nextInnerText && !nextHasBold) {
                    const originalHtml = nextLi.innerHTML;
                    const content = getContent(nextLi);
                    sectionChildren.push({
                        tag: '综合分析',
                        subTitle: '',
                        content: content || nextInnerText,
                        links: extractLinksHtml(originalHtml),
                        sources: extractSources(originalHtml || nextInnerText)
                    });
                    i++;
                    continue;
                } else if (isSummary(nextBold)) {
                    const originalHtml = nextLi.innerHTML;
                    const content = getContent(nextLi);
                    sectionChildren.push({
                        tag: nextBold,
                        subTitle: '',
                        content: content,
                        links: extractLinksHtml(originalHtml),
                        sources: extractSources(originalHtml)
                    });
                    i++;
                    continue;
                }
            }
            continue;
        }

        // ---- 二级标题 ----
        if (currentSection && !isSummary(boldText)) {
            const innerUl = li.querySelector(':scope > ul');

            if (innerUl) {
                const subTitle = boldText;
                const items = [];

                const subLis = innerUl.querySelectorAll(':scope > li');
                for (const subLi of subLis) {
                    const subBold = getBoldText(subLi);
                    if (!subBold) {
                        const originalHtml = subLi.innerHTML;
                        const content = getContent(subLi);
                        if (content) {
                            items.push({
                                tag: '',
                                title: '',
                                content,
                                links: extractLinksHtml(originalHtml),
                                sources: extractSources(originalHtml)
                            });
                        }
                        continue;
                    }

                    const tagMatch = subBold.match(/【([^】]+)】/);
                    const tag = tagMatch ? tagMatch[1] : '';
                    const itemTitle = subBold.replace(/【[^】]+】/, '').trim();
                    const originalHtml = subLi.innerHTML;
                    const content = getContent(subLi);

                    if (itemTitle || content) {
                        items.push({
                            tag,
                            title: itemTitle,
                            content,
                            links: extractLinksHtml(originalHtml),
                            sources: extractSources(originalHtml)
                        });
                    }
                }

                if (items.length > 0) {
                    sectionChildren.push({ subTitle, items, subTitleShow: true });
                }
            }
        }
    }

    if (currentSection) {
        currentSection.children = sectionChildren;
        sectionsData.push(currentSection);
    }

    // 如果 sectionsData 为空，使用 fallback 方法
    if (sectionsData.length === 0) {
        return extractWithFallback(doc, h2s);
    }

    return { articleTitle, sections: sectionsData };
};

/**
 * Fallback 提取方法 - 处理 ul > li 结构，支持多个一级标题
 */
/**
 * Fallback 提取方法 - 处理 ul > li 结构，支持多个一级标题
 * 每个 section 对应一个 h2 标题（如 1.行业趋势与品类变化）
 */
/**
 * Fallback 提取方法 - 处理 ul > li 结构，支持多个一级标题
 * 每个 section 对应一个 h2 标题（如 1.行业趋势与品类变化）
 */
function extractWithFallback(doc, h2s) {
    let articleTitle = '';
    const sections = [];

    const h2Array = Array.from(h2s);

    if (h2Array.length > 0) {
        articleTitle = h2Array[0].textContent.trim();
    }

    const sectionH2s = [];
    for (let i = 0; i < h2Array.length; i++) {
        const text = h2Array[i].textContent.trim();
        if (!text.includes('周报') && text) {
            sectionH2s.push({
                index: i,
                title: text,
                element: h2Array[i]
            });
        }
    }

    if (sectionH2s.length === 0) {
        for (let i = 1; i < h2Array.length; i++) {
            const text = h2Array[i].textContent.trim();
            if (text) {
                sectionH2s.push({
                    index: i,
                    title: text,
                    element: h2Array[i]
                });
            }
        }
    }

    function extractLinksHtml(el) {
        if (!el) return '';
        const links = [];
        const aTags = el.querySelectorAll('a.quote');
        aTags.forEach(a => {
            const clone = a.cloneNode(true);
            clone.removeAttribute('href');
            links.push(clone.outerHTML);
        });
        return links.join('');
    }

    function extractSources(text) {
        if (!text) return [];
        const sources = [];
        const multiRegex = /[（(]([^）)]+)[）)]/g;
        let match;
        while ((match = multiRegex.exec(text)) !== null) {
            const content = match[1];
            const parts = content.split(/[；;]\s*/);
            for (const part of parts) {
                let itemMatch = part.match(/^([^，,]+)[，,]\s*(\d{4}-\d{2}-\d{2})/);
                if (!itemMatch) {
                    itemMatch = part.match(/^(.+?)\s+(\d{4}-\d{2}-\d{2})$/);
                }
                if (itemMatch) {
                    sources.push({
                        title: itemMatch[1].trim(),
                        time: itemMatch[2].trim()
                    });
                }
            }
        }
        if (sources.length === 0) {
            const regex = /[（(]([^，,）)]+)[，,]\s*(\d{4}-\d{2}-\d{2})[）)]/g;
            while ((match = regex.exec(text)) !== null) {
                sources.push({
                    title: match[1].trim(),
                    time: match[2].trim()
                });
            }
            const regexSpace = /[（(](.+?)\s+(\d{4}-\d{2}-\d{2})[）)]/g;
            while ((match = regexSpace.exec(text)) !== null) {
                const exists = sources.some(s => s.title === match[1].trim() && s.time === match[2].trim());
                if (!exists) {
                    sources.push({
                        title: match[1].trim(),
                        time: match[2].trim()
                    });
                }
            }
        }
        return sources;
    }

    sectionH2s.forEach((sectionH2, idx) => {
        const cleanTitle = sectionH2.title.replace(/^\d+\.\s*/, '');

        let ulElement = null;
        let next = sectionH2.element.nextElementSibling;
        while (next) {
            if (next.tagName === 'UL') {
                ulElement = next;
                break;
            }
            next = next.nextElementSibling;
        }

        if (!ulElement) {
            const allUls = doc.querySelectorAll('ul');
            if (idx < allUls.length) {
                ulElement = allUls[idx];
            }
        }

        if (ulElement && ulElement.tagName === 'UL') {
            const topLevelLis = ulElement.querySelectorAll(':scope > li');
            const children = [];

            topLevelLis.forEach(topLi => {
                const contentUl = topLi.querySelector(':scope > ul');
                const hasChildUl = !!contentUl;

                if (hasChildUl && contentUl) {
                    let subTitle = '';
                    const boldTextEl = topLi.querySelector(':scope > text[style*="font-weight:bold"]');
                    if (boldTextEl) {
                        subTitle = boldTextEl.textContent.trim();
                    }
                    if (!subTitle) {
                        const boldTextEl2 = topLi.querySelector(':scope > b > text[style*="font-weight:bold"]');
                        if (boldTextEl2) {
                            subTitle = boldTextEl2.textContent.trim();
                        }
                    }
                    if (!subTitle) {
                        const allBold = topLi.querySelectorAll('[style*="font-weight:bold"]');
                        if (allBold.length > 0) {
                            subTitle = allBold[0].textContent.trim();
                        }
                    }
                    if (!subTitle) {
                        const textEl = topLi.querySelector(':scope > text');
                        if (textEl) {
                            subTitle = textEl.textContent.trim().replace(/\s*\d+\s*$/, '').trim();
                        }
                    }

                    const items = [];
                    const contentLis = contentUl.querySelectorAll(':scope > li');
                    contentLis.forEach(li => {
                        let title = '';
                        const titleEl = li.querySelector('b > text');
                        if (titleEl) {
                            title = titleEl.textContent.trim().replace(/\s+/g, ' ');
                        }
                        if (!title) {
                            const boldEl = li.querySelector('[style*="font-weight"]');
                            if (boldEl) {
                                title = boldEl.textContent.trim().replace(/\s+/g, ' ');
                            }
                        }
                        if (!title) {
                            const textEl = li.querySelector(':scope > text');
                            if (textEl) {
                                title = textEl.textContent.trim().replace(/\s+/g, ' ');
                            }
                        }

                        const clone = li.cloneNode(true);
                        clone.querySelectorAll('b').forEach(el => el.remove());
                        clone.querySelectorAll('[style*="font-weight"]').forEach(el => el.remove());
                        clone.querySelectorAll('a.quote').forEach(el => el.remove());
                        clone.querySelectorAll('br').forEach(el => el.remove());
                        let content = clone.textContent.trim().replace(/\s+/g, ' ');
                        if (title && content.startsWith(title)) {
                            content = content.substring(title.length).trim();
                        }
                        content = content.replace(/^[：:]\s*/, '').trim();

                        const links = extractLinksHtml(li);
                        const sources = extractSources(li.innerHTML || content);

                        if (title || content) {
                            items.push({
                                tag: '',
                                title: title || '',
                                content: content || '',
                                links: links,
                                sources: sources,
                                expanded: false,
                                showExpandBtn: false
                            });
                        }
                    });

                    if (items.length > 0) {
                        children.push({
                            subTitle: subTitle || '',
                            items: items,
                            subTitleShow: true
                        });
                    }
                } else {
                    const items = [];
                    const textEls = topLi.querySelectorAll(':scope > text');
                    textEls.forEach(textEl => {
                        let title = textEl.textContent.trim().replace(/\s*\d+\s*$/, '').trim();
                        if (title) {
                            let links = '';
                            let sources = [];
                            let content = '';
                            
                            // ---- 关键修复：从 topLi 的完整文本中提取 content ----
                            const fullText = topLi.textContent || '';
                            let contentText = fullText.replace(title, '').trim();
                            contentText = contentText.replace(/\s*\d+\s*$/, '').trim();
                            contentText = contentText.replace(/[（(][^）)]+[）)]/g, '').trim();
                            contentText = contentText.replace(/^[：:]\s*/, '').trim();
                            content = contentText.replace(/\s+/g, ' ').trim();
                            
                            const nextSibling = textEl.nextElementSibling || textEl.nextSibling;
                            if (nextSibling && nextSibling.tagName === 'A') {
                                const classAttr = nextSibling.className || '';
                                if (classAttr && classAttr.includes('quote')) {
                                    const clone = nextSibling.cloneNode(true);
                                    clone.removeAttribute('href');
                                    links = clone.outerHTML;
                                    sources = extractSources(nextSibling.outerHTML || nextSibling.textContent || '');
                                }
                            }
                            
                            items.push({
                                tag: '',
                                title: title,
                                content: content || '',
                                links: links,
                                sources: sources,
                                expanded: false,
                                showExpandBtn: false
                            });
                        }
                    });

                    if (items.length > 0) {
                        children.push({
                            subTitle: '',
                            items: items,
                            subTitleShow: true
                        });
                    }
                }
            });

            if (children.length > 0) {
                sections.push({
                    title: cleanTitle,
                    preTitle: sectionH2.title,
                    children: children,
                    show: false,
                    sectionshow: true
                });
            }
        } else {
            sections.push({
                title: cleanTitle,
                preTitle: sectionH2.title,
                children: [],
                show: false,
                sectionshow: true
            });
        }
    });

    if (sections.length === 0) {
        for (let i = 1; i < h2Array.length; i++) {
            const h2 = h2Array[i];
            const text = h2.textContent.trim();
            if (text) {
                const cleanTitle = text.replace(/^\d+\.\s*/, '');
                sections.push({
                    title: cleanTitle,
                    preTitle: text,
                    children: [],
                    show: false,
                    sectionshow: true
                });
            }
        }
    }

    return {
        articleTitle: articleTitle,
        sections: sections
    };
}

const  toCopy=async()=>{
	 const { toClipboard } = useClipboard()

        var contentC = aiContent.value
      

            //删除a标签
            contentC = contentC.replace(/<a[^>]*>.*?<\/a>/g, '')
            console.log(contentC, '周报内容')

            contentC =  contentC.replace(/<\/?(?:span|text|strong)[^>]*>/g, '')



          contentC = contentC.replace(/<img [^\>]*\/>/g, '')

          contentC = contentC.replace(/<[^>]+>/g, "\n")
          contentC = contentC.replace(/\n+/g, '\n')
        contentC=contentC.replace(/&nbsp;/g, '')
         
       
        try {

          await toClipboard(contentC.trim())
          message.success('复制成功', 10);
        } catch (err) {
          console.error('复制失败:', err);
          message.error('复制失败，请手动复制', 10);
        }
     
}

		return {
			toCopy,
			showFlag,
			scrolldivRef,
			toggleCardExpand,
			setTextRef,
			textRefs,
			setOffsetTop,
			offsetTop,

			toGetResize,
			linkArticle,

			clickLinkArticle,
			clickLinkArticleItem,

			linkList,

			aiContent,
			aiCategoryId,
			aiContentClick,
			linkSrc: 'https://enplus.oss-cn-guangzhou.aliyuncs.com/file/ea4d857a-0283-42db-b265-92658fc03803.png',
			categoryPageClick,
			fontSize,
			scrollY,

			toGetUserInfor,
			todayImg,

			scrolldiv,

			reloadSpinning,

			// UI 控制：tabs / banner
			tabs,
			activeTab,
			bannerTitle,
			dateRange,
			totalCount,
			// 折叠状态与切换方法
			collapsed,
			toggleSection,

			previewCards,
			extractedData
		}
	},
	beforeRouteLeave(to, from, next) {
		if (to.path == '/INT' || to.path == '/main') {
			this.scrollY = 0
		}
		else
			//保存滚动条元素div的scrollTop值
			this.scrollY = document.querySelector('.scrolldiv').scrollTop
		next();
	},
}
</script>
<style lang="scss" scoped>
@import '../../assets/style.scss';
.weekscroll{
	display: block !important;
	
}
.banner-area{
	 box-shadow: 0 8px 20px rgba(16, 24, 40, 0.06); position: sticky;  top: 0;   z-index: 100;background-color: white;padding:15px 40px 0px 40px 
}

.page-container {
	background: #f7f7f7;
	min-height: 100vh;
	padding: 0px 0px 40px 0px !important;
	width: 100%;
}


.ubutton-class {
	padding: 0 10px !important;
	border: none !important;
	cursor: pointer;

	.u-hairline-border::after {
		border: none !important;
	}
}

.introduce {
	color: #888e90;
	cursor: pointer;
	font-size: 15px;
	line-height: 22px;
	text-overflow: ellipsis;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	line-clamp: 4;
	-webkit-box-orient: vertical;
	padding: 0px 12px 0px 12px;
	text-align: justify;
}

.introduceSmall {
	font-size: 13px !important;
}

.introduceBig {
	font-size: 17px !important;
}

.inline-content {
	cursor: pointer;
}

.inline-content {
	a {
		color: rgba(0, 0, 0, 0.9);
	}


}

.inline-content:hover {
	a {
		color: #315efb !important;
	}

}

.introduce:hover {
	color: #babcbc !important;

}

.scrolldiv {
	justify-content: center;
	display: flex;
}

.catalog-article-detail {


	.home {
		margin-left: 24px;
		width: 48px;
		height: 48px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;

		.home-img {
			width: 48px;
			height: 48px;
		}
	}

	.detail {
		padding: 20px 20px 80px;
		font-size: 24px;

		position: relative;

		.powerby {


			.powerby-image {
				width: 100%;
			}
		}










	}
}


.linkArticle {
	display: none;
	background-color: white;

	position: absolute;
	color: #009DA6;
	left: 0;
	right: 0;
	overflow-y: auto;
	margin: auto;
	max-height: 300px;
	width: 90%;
	padding: 10px 10px;
	border-radius: 10px;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}


.linkItem {
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	font-size: 15px;
	line-height: 30px;
	width: 95%;
	cursor: pointer
}

.linkItem:hover {
	color: #1890ff;
}

/* 新增：符合图片视觉的头部、横幅与标签样式 */
.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 16px;
	background: #fff;
	position: sticky;
	top: 0;
	z-index: 30;
	border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.header .back {
	font-size: 22px;
	cursor: pointer;
}

.header .title {
	font-size: 18px;
	font-weight: 600;
}

.header .actions {
	display: flex;
	gap: 8px;
	align-items: center;
	color: #333;
}

// .content-wrap {
// 	width: 80%;
// 	margin: 16px auto;
// }

.banner-card {
	display: flex;
    align-items: center;
    background-image: url(https://enplus.oss-cn-guangzhou.aliyuncs.com/file/96e1ef3e-2e4f-45be-b328-525db0bb8e0f.png);
    border-radius: 12px;
    padding: 10px;
    box-shadow: none;
    background-repeat: unset;
    background-size: cover;
    background-position: center;
}

.banner-left {
	margin-right: 12px
}

.icon-round {
	    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #E3F4F3;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.icon-round img {
	    width: 30px;
    height: 30px;
}

.banner-right {
	flex: 1
}

.banner-title {
	font-size: 18px;
	font-weight: 700;
	color: #083333
}

.banner-sub {
	color: #5b7b7a;
	margin-top: 6px
}

.tabs {
    display: flex;
    gap: 24px;
    padding: 10px 6px;
    background: #fff;
    overflow-x: auto;
    border-bottom: 1px solid #f0f0f0;
}
.tab:hover{
  color: #0aa39a;

}

.tab {
	padding: 8px 4px;
	color: #6b6b6b;
	cursor: pointer;
	position: relative
}

.tab.active {
	color: #0aa39a;
	font-weight: 600
}

.tab.active::after {
	    content: "";
    height: 3px;
    // width: 24px;
    background: #0aa39a;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    margin: 0 auto;
    border-radius: 2px;
}

.list-area {
	padding: 12px 0
}

.section .card {
	background: #fff;
	border-radius: 10px;
	padding: 16px;
	margin-bottom: 16px;
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06)
}



/* 调整 list-area / section 样式以匹配设计图 */
.list-area {
	padding: 18px 0 40px;
	position: relative;
}

.section-block {
	margin-top: 18px;
}

.section-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 14px;
	background: transparent;
}

.section-left {
	display: flex;
	align-items: center;
	gap: 12px;
	width: 100%;
}

.section-left .mark {
	width: 6px;
	height: 28px;
	background: #10a39a;
	border-radius: 4px;
}

.section-left .section-index {
	color: #0b2b2b;
	font-weight: 700;
	font-size: 14px
}

.section-left .section-title-text {
	font-size: 18px;
	font-weight: 700;
	color: #0b2b2b
}

.section-right {
	display: flex;
	align-items: center;
	gap: 12px
}

.section-right .section-sub {
	color: #9aa9a8;
	font-size: 13px
}

.collapse-icon {
	font-size: 18px;
	color: #333
}

.cards-container {
	margin-top: 10px
}

.cards-inner .report-card {
	background: #fff;
	border-radius: 12px;
	padding: 18px 18px 14px;
	margin-bottom: 16px;
	box-shadow: 0 8px 20px rgba(16, 24, 40, 0.06);
	border: 1px solid rgba(15, 34, 32, 0.04);
	overflow: hidden;
}

.cards-inner .report-card .pill-tag,
.cards-inner .report-card .tag {
	background: #e9f7f6;
	color: #0a9f97;
	padding: 6px 6px;
	border-radius: 8px;
	font-size: 13px;
	margin-right: 12px;
	border: 1px solid #0a9f97;
}

.card-title {
	font-weight: bolder;
	font-size: 16px;
	line-height: 2;
	text-align: justify;
}

.cards-inner .report-card h3,
.cards-inner .report-card strong {
	font-size: 18px;
	font-weight: 700;
	color: #0b2b2b
}

.cards-inner .report-card p {
	color: #555;
	line-height: 1.8;
	margin-top: 12px;
	// overflow: hidden;
	// display: -webkit-box;
	// -webkit-line-clamp: 3;
	// -webkit-box-orient: vertical;
	// max-height: calc(1.8em * 3 + 12px);
}

/* 将展开按钮居中并样式化 */
.expand-btn {
	display: inline-block;
	background: #e8faf9;
	color: #0aa39a;
	padding: 8px 14px;
	border-radius: 18px;
	margin: 12px auto 0;
	border: none;
	text-decoration: none;
	cursor: pointer;
	user-select: none;
	display: block;
	width: max-content;
}

.expand-btn::after {
	content: ' ↓';
	font-size: 12px;
	margin-left: 4px
}

.disexpand-btn::after {
	content: ' ↑';
	font-size: 12px;
	margin-left: 4px
}

/* 卡片展开时移除段落高度限制 */
.cards-inner .report-card {
	transition: box-shadow .18s ease
}

.cards-inner .expanded {
	box-shadow: 0 12px 30px rgba(16, 24, 40, 0.08)
}

.cards-inner .expanded p {
	/* 取消多行截断样式，恢复正常块级流排布，避免按钮与文本重叠 */
	display: block !important;
	-webkit-line-clamp: unset !important;
	-webkit-box-orient: unset !important;
	max-height: none !important;
	overflow: visible !important;
}

/* 确保展开按钮位于段落下方并居中 */
.expand-btn {
	display: block !important;
	margin: 12px auto 0 !important;
	clear: both;
	z-index: 1;
}

/* 卡片底部 meta */
.cards-inner .report-card .meta {
	display: flex;
	gap: 12px;
	color: #9aa9a8;
	margin-top: 14px;
	font-size: 13px;
	align-items: center;
	border-top: 1px solid;
	padding-top: 10px;
	    flex-wrap: wrap;
}

.cards-inner .report-card .meta .dot {
	width: 4px;
	height: 4px;
	background: #cfdcdc;
	border-radius: 50%;
	display: inline-block;
	margin: 0 6px
}
</style>
<style lang="less">
.ai-category {
	padding: 0px 32px 32px 32px;
	line-height: 36px !important;

	ul {
		list-style-type: disc;
		padding-left: 2em;
	}

	.quote {
		line-height: 12px !important;
	}

	ul ul {
		list-style-type: circle;
	}

	h2 {
		font-weight: bold;

		strong {
			font-weight: bold;
			color: #595959;
		}
	}


}

</style>
